export const QwilrElementTypeId = Object.freeze({
    Text: 1,
    Splash:2,
    Video:3,
    QuoteV2:4,
    Accept:5,
    Source:6,
    Template:7,
    Agreement:8
  });

  const disabledElements = new Set([QwilrElementTypeId.Source, QwilrElementTypeId.Agreement]);

  export const DisabledElements = {
    isDisabled: (elementId) => disabledElements.has(elementId)
  };
